export enum FieldNames {
  Sites = 'sites',
  Equipment = 'equipment',
  Reset = 'reset',
}
